import React from "react";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="border-b border-zinc-200/70"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-4">
            <span className="section-label">About</span>
            <h2 className="mt-4 font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-zinc-900 tracking-tight leading-[1.05]">
              A quiet partner in your launch.
            </h2>
          </div>

          <div className="lg:col-span-8 space-y-6 text-zinc-700 text-lg md:text-xl leading-relaxed max-w-2xl">
            <p>
              I work with creators who already have an audience but haven&rsquo;t turned that attention into a product yet. My job is to take what you&rsquo;ve built and shape it into something people can actually buy.
            </p>
            <p className="text-zinc-500">
              Clear positioning. A product that fits. A launch you don&rsquo;t have to over-think. We work on a revenue split, so my outcome is tied directly to yours.
            </p>

            <div className="pt-6 grid grid-cols-2 sm:grid-cols-3 gap-6 border-t border-zinc-200">
              <Stat label="Approach" value="Hands-on" />
              <Stat label="Model" value="Revenue split" />
              <Stat label="Focus" value="Creators" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Stat = ({ label, value }) => (
  <div className="pt-6">
    <div className="text-xs uppercase tracking-[0.2em] font-semibold text-zinc-400">
      {label}
    </div>
    <div className="mt-2 font-heading text-2xl md:text-3xl font-semibold text-zinc-900">
      {value}
    </div>
  </div>
);

export default About;
